import React from "react";

export const texts = {
    app: {
        headers: {
            userAddress: (userAddress?: string[]) =>
                `User address : ${userAddress}`,
            userBalance: (ethBalance?: string, daiBalance?: string) =>
                `ETH : ${ethBalance ? ethBalance : "-"} / DAI : ${
                    daiBalance ? daiBalance : "-"
                }`,
        },
        title: (
            vaultedDaiAmount: string,
            providerName: string,
            interestRate: string
        ) => (
            <p>
                You currently have <b>{vaultedDaiAmount}</b> DAI vaulted with
                provider <b>{providerName}</b> and <b>{interestRate}%</b>{" "}
                interest
            </p>
        ),
        table: {
            defaultHeader: [
                "Swap ID",
                "Swap Date",
                "Old Provider",
                "Old interest rate",
                "New Provider",
                "New interest rate",
            ],
            defaultRows: [
                [
                    "#2",
                    "07/07/2020 23:54",
                    "Provider 1",
                    "1%",
                    "Provider 3",
                    "0.8%",
                ],
                [
                    "#1",
                    "07/07/2020 23:12",
                    "Provider 2",
                    "2%",
                    "Provider 1",
                    "1%",
                ],
            ],
        },
        buttons: {
            createMakerVault: "Create Maker Vault",
            setupGelato: "Setup Gelato Optimizer",
            createDsa: "Create DSA (optional)",
        },
    },
};
